const CACHE_LOADED = 'CACHE_LOADED';

const events = [CACHE_LOADED];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);
};

export const MULTISELECT_EVENTS = {
  CACHE_LOADED,
  initializeEventListeners,
};
